import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtendedStopCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16.0833 31.9166H31.9166V16.0833H16.0833V31.9166ZM24 43.7916C21.2621 43.7916 18.6892 43.2721 16.2812 42.233C13.8732 41.1939 11.7786 39.7838 9.99738 38.0025C8.21613 36.2213 6.80597 34.1267 5.76691 31.7187C4.72784 29.3107 4.20831 26.7378 4.20831 23.9999C4.20831 21.2621 4.72784 18.6892 5.76691 16.2812C6.80597 13.8732 8.21613 11.7786 9.99738 9.99732C11.7786 8.21606 13.8732 6.80591 16.2812 5.76685C18.6892 4.72778 21.2621 4.20825 24 4.20825C26.7378 4.20825 29.3107 4.72778 31.7187 5.76685C34.1267 6.80591 36.2213 8.21606 38.0026 9.99732C39.7838 11.7786 41.194 13.8732 42.2331 16.2812C43.2721 18.6892 43.7917 21.2621 43.7917 23.9999C43.7917 26.7378 43.2721 29.3107 42.2331 31.7187C41.194 34.1267 39.7838 36.2213 38.0026 38.0025C36.2213 39.7838 34.1267 41.1939 31.7187 42.233C29.3107 43.2721 26.7378 43.7916 24 43.7916ZM24 39.8333C28.4201 39.8333 32.164 38.2994 35.2318 35.2317C38.2995 32.164 39.8333 28.4201 39.8333 23.9999C39.8333 19.5798 38.2995 15.8359 35.2318 12.7681C32.164 9.70044 28.4201 8.16659 24 8.16659C19.5798 8.16659 15.8359 9.70044 12.7682 12.7681C9.7005 15.8359 8.16665 19.5798 8.16665 23.9999C8.16665 28.4201 9.7005 32.164 12.7682 35.2317C15.8359 38.2994 19.5798 39.8333 24 39.8333Z",
		fill: "url(#paint0_linear_20197_77761)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_20197_77761",
		x1: 4.00003,
		y1: 44.3125,
		x2: 50.6828,
		y2: 13.9686,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#142F95" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .5,
				stopColor: "#2563EB"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#CACBFF"
			})
		]
	}) })]
});
export default SvgExtendedStopCircle;
